<template>
  <div id="card" class="card">
    <div class="card-info">
      <div class="userImg" @click="playVideo()">
        <img :src="data.portrait" alt="">
      </div>
      <div class="user-text">
        <div class="userName">
          <div>
            <span>{{data.nickName}}</span>
            <span>
              <img v-if="data.city" src="~assets/images/card/address.png" alt="">  
                  {{data.city}}
            </span>
          </div>
          <div>{{data.operationTime.slice(0, 10)}}</div>
        </div>
        <div class="bonus">
          <span>中奖金额：{{ data.bonus.slice(0, -2) }}元</span>
        </div>
      </div>
	  </div>
    <div class="detail">
      <div class="message">
        <span>{{data.message}}</span>
      </div>
      <div class="imgList">
        <div class="imgList-video-img" v-if="data.pictures[0].indexOf('mp4') !== -1">
          <div class="imgList-video-img-part-one" @click.stop="show(data.pictures[0], data.pictures[1])" >
            <video class="smallVideo" playsinline preload="none" loop muted :poster="data.pictures[1]" :src="data.pictures[0]"></video>
            <img class="poster" :src="data.pictures[1]" alt="">
            <img class="pauseIcon" src="~assets/images/card/play.png" alt="">
          </div>
          <img v-for="(item, index) in data.pictures.slice(2)" :key="item" @click="handleImgsClick(index)" :src="item" alt="">
        </div>
        <div class="imgList-img" v-else>
          <img class="smallVideo" v-for="(item, index) in data.pictures.slice(0)" :key="item" @click="handleImgsClick(index)" :src="item" alt="">
          <img :style="{display: 'none'}" class="poster" :src="data.pictures[1]" alt="">
          <img :style="{display: 'none'}" class="pauseIcon" src="~assets/images/card/play.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['data'],
  data() {
    return {
	  	scale: '',
      initialIndex: 0,
    }
  },
  methods: {
	  handleImgsClick(index) {
      this.initialIndex = index
      const params = {
        $props: {
          imgs: this.data.pictures[0].indexOf('mp4') != -1 ? this.data.pictures.slice(2) :  this.data.pictures,
          initialIndex: 'initialIndex', // 响应式数据的key名
          loop: false
        },
        $events: {
          change: (i) => {
            // 必须更新 initialIndex
            this.initialIndex = i
          }
        }
      }
      this.$createImagePreview({ ...params }).show()
    },
    playVideo() {
      let video = document.getElementsByClassName('smallVideo');
      video[0] ? video[0].play() : '';
    },
    show(src, poster) {
        this.$emit('send', [src, poster])
     }
    }
  }

</script>
<style lang="less" scoped>
.card {
  border-bottom: 1px solid #eee;
  padding: 0.1875rem;
  font-size: 14px;
  font-family: "Microsoft YaHei",'微软雅黑',"MicrosoftJhengHei";
  .card-info {
    overflow: hidden;
    .userImg {
      width: 0.4388rem;
      height: 0.4388rem;
      float: left;
      img {
        width: 0.4388rem;
        height: 0.4388rem;
        border-radius: 50%;
      }
    }
    .user-text {
      width: 82%;
      margin-left: 0.112rem;
      float: left;
      .userName {
        margin: 0.01875rem 0;
        display: flex;
        justify-content: space-between;
        div {
          &:first-child {
            text-align: left;
            white-space: nowrap;
            text-overflow: ellipsis;
            span {
              font-size: 0.15rem;
              font-weight: 700;
              line-height: 0.1875rem;
              &:last-child {
                font-weight: 500;
                color: #999999;
                font-size: 0.12rem;
                line-height: 0.1875rem;
                position: relative;
                margin-left: 0.15rem;
                top: -0.015rem;
                img {
                  width: 0.1313rem;
                  position: absolute;
                  top: 0.01125rem;
                  left: -0.1313rem;
                }
              }
            }
          }
          &:last-child {
            color: #999999;
            font-size: 0.12rem;
            line-height: 0.15rem;
          }
        }
      }
      .bonus {
        display: flex;
        line-height: 0.19875rem;
        color: #FA584C;
        margin-top: 0.075rem;
        span {
          font-weight: 700;
          font-size: 0.146rem;
        }
      }
    }
  }
  .detail {
    width: 100%;
    margin-top: 0.075rem;
    .message{
      width: 100%;
      margin-bottom: 0.16rem;
      text-align: left;
      font-size: 0.13875rem;
      line-height:0.221rem;
      letter-spacing: 0.015px;
    }
    .imgList {
      overflow: hidden;
      .imgList-video-img {
        >* {
          width: 1.0875rem;
          height: 1.0875rem;
          overflow: hidden;
          border-radius: 0.07rem;
          float: left;
          margin-bottom: 0.05625rem;
        }
        :nth-child(1) {
          margin-right: 0.05625rem;
          width: 2.2313rem;
          height: 2.2313rem;
          position: relative;
            video {
            width: 100%;
            height: 100%;
            }
          .poster {
            width: 200%;
            height: 200%;
            margin-left: -40%;
            margin-top: -115%;
            position: relative;
          }
          .pauseIcon {
            width: 0.375rem;
            height: 0.375rem;
            position: absolute;
            left: 50%;
            top: 50%;
            margin-top: -0.1875rem;
            margin-left: -0.1875rem;
          }
        }
      }
      .imgList-img {
        img {
          width: 1.06875rem;
          height: 1.06875rem;
          margin-right: 0.08438rem;
          margin-bottom: 0.08438rem;
          float: left;
          border-radius: 0.07rem;
          &:nth-child(3n) {
            margin-right: 0;
          }
        }
      }
    }
  }
}

</style>